import utils from '@src/common/utils'
import { Dic } from '$utils'
const tableOption = function(that) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [
      {
        label: '图片',
        prop: 'fileCode',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        viewslot: true,
        span: 24,
        align: 'center',
        rules: [{ required: true, message: '请上传图片', trigger: 'blur' }],
      },
      {
        label: '资产名称',
        prop: 'fireassetName',
        search: true,
        addDisplay: true,
        editDisplay: true,
        editDisabled: true,
        viewDisplay: true,
        overHidden: true,
        rules: [{ required: true, message: '请输入资产名称', trigger: 'blur' }],
      },
      {
        label: '资产类型',
        prop: 'fireassetType',
        type: 'select',
        search: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        editDisabled: true,
        overHidden: true,
        align: 'center',
        span: 12,
        dicData: Dic.find('SENU077'),
        viewFormatter: (row, value) => {
          if (value) {
            console.log(Dic.findByValue('SENU077', Number(value)))
            return Dic.findByValue('SENU077', Number(value))
          }
          return ''
        },
        rules: [{ required: true, message: '请选择资产类型', trigger: 'blur' }],
        formatter: function(row, value) {
          return value ? Dic.findByValue('SENU077', Number(value)) : ''
        },
      },
      {
        label: '厂家',
        prop: 'manufacturer',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        align: 'center',
      },
      {
        label: '品牌',
        prop: 'brand',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        align: 'center',
      },
      {
        label: '所在区域',
        prop: 'areaName',
        search: true,
        searchSlot: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        span: 12,
        align: 'center',
        placeholder: '请选择区域',
      },
      {
        label: '是否在室内',
        prop: 'isindoor',
        type: 'select',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        align: 'center',
        viewFormatter: (row, value) => {
          if (Number(value) === 0) {
            return '否'
          } else if (Number(value) === 1) {
            return '是'
          }
          return ''
        },
        dicData: [
          {
            label: '否',
            value: '0',
          },
          {
            label: '是',
            value: '1',
          },
        ],
      },
      {
        label: '楼层',
        prop: 'floor',
        type: 'select',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        align: 'center',
        viewFormatter: (row, value) => {
          if (value) {
            return value + '楼'
          }
          return ''
        },
        dicData: (() => {
          const floor = []
          for (let index = 0; index < 20; index++) {
            floor.push({
              label: index + 1 + '楼',
              value: (index + 1).toString(),
            })
          }
          return floor
        })(),
      },
      {
        label: '价格',
        prop: 'value',
        align: 'center',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
      },
      {
        label: '经度',
        prop: 'longitude',
        align: 'center',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        span: 12,
      },
      {
        label: '纬度',
        prop: 'latitude',
        align: 'center',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        viewslot: false,
        span: 12,
      },

      {
        label: '出厂日期',
        prop: 'productionTime',
        type: 'date',
        value: '',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        formatter: function(row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD') : ''
        },
      },
      {
        label: '使用情况',
        prop: 'status',
        type: 'select',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        span: 12,
        viewFormatter: (row, value) => {
          if (Number(value) === 0) {
            return '库存中'
          } else if (Number(value) === 1) {
            return '使用中'
          }
          return ''
        },
        dicData: [
          {
            label: '库存中',
            value: 0,
          },
          {
            label: '使用中',
            value: 1,
          },
        ],
        align: 'center',
      },
      {
        label: '资产描述',
        prop: 'desc',
        type: 'textarea',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        minRows: 3,
        span: 24,
        maxlength: 200,
      },
      {
        label: '设备二维码',
        prop: 'deviceQrCode',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 12,
        align: 'center',
      },
    ],
  }
}
export default tableOption
